import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = (set, get) => ({
  decisionFlow: [],
  selectedQuestion: {},
  questionMessages: [],
  newDecisionFlowItem: (newItem) =>
    set((state) => ({ decisionFlow: [...state.decisionFlow, newItem] })),
  removeDecisionFlowItem: () =>
    set((state) => ({
      selectedQuestion: state.decisionFlow[state.decisionFlow.length - 1],
      decisionFlow: [...state.decisionFlow.slice(0, -1)],
    })),
  resetDecisionFlowItem: () =>
    set((state) => ({
      selectedQuestion: {},
      decisionFlow: [],
      questionMessages: [],
    })),
  setSelectedQuestion: (question) =>
    set((state) => ({ selectedQuestion: question })),
  newQuestionMessage: (newMessage) =>
    set((state) => ({
      questionMessages: [...state.questionMessages, newMessage],
    })),
});

export const useFDAChangeManagementStore = create(
  persist(store, { name: "fda-change-management-store" }),
);
